angular.module('angus.controllers').directive('delivery', function() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'templates/tankMonitor/inventoryManagement/delivery/deliveryView.html'
    };
});